import script from "./ProjectTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectTitle.vue?vue&type=script&setup=true&lang=js"

import "./ProjectTitle.vue?vue&type=style&index=0&id=4d935742&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d935742"]])

export default __exports__